import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {handleKeyPressSpecialCharacters} from "../../../../../common/utils/Utils";
import {smartPosStore} from "../SmartPosStore";
import SelectStatus from "../../../../../shared/components/form/SelectStatus";
import {vendorSmartPos} from "../../../../../common/constants/Constants";
import SelectCustom from "../../../../../shared/components/form/SelectCustom";
import useDebounce from "../../../../../common/customHook/useDebounce";
import {useNavigate} from "react-router-dom";

const Filter = () => {
    const navigate = useNavigate();
    const debouncedSearchTable= useDebounce(smartPosStore.searchTemp, 300);
    const updateUrlParams = () => {
        const searchParams = new URLSearchParams();

        if (debouncedSearchTable) {
            searchParams.set(
                "search",
                debouncedSearchTable
            );
        }
        if (smartPosStore.staticParam.status) {
            searchParams.set(
                "status",
                smartPosStore.staticParam.status
            );
        }
        if (smartPosStore.staticParam.vendor_name) {
            searchParams.set(
                "vendor_name",
                smartPosStore.staticParam.vendor_name
            );
        }
        smartPosStore.staticParam.page_number = 0;
        navigate({ search: searchParams.toString() }, { replace: true });
        smartPosStore.fetchListSmartPos()
    };

    const handleRemoveFilters = () => {
        smartPosStore.searchTemp = "";
        smartPosStore.staticParam.search = "";
        smartPosStore.staticParam.status = "";
        smartPosStore.staticParam.vendor_name = "";
        smartPosStore.staticParam.page_number = 0;
        navigate({search: ""}, {replace: true});
        smartPosStore.fetchListSmartPos();
    };

    useEffect(() => {
        // smartPosStore.allowSearch: khi load lại trang không bay vào đây tránh mất search trên url
        if (smartPosStore.allowSearch && debouncedSearchTable !== smartPosStore.staticParam.search) {
            smartPosStore.staticParam.search = debouncedSearchTable;
            updateUrlParams();
        }
    }, [debouncedSearchTable]);
    
    return (
        <>
            <div className="box-filter">
                <div className="search">
                    <img src="/assets/icon/searchModel.svg" alt="searchModel"/>
                    <input
                        type="text"
                        placeholder="Tìm kiếm"
                        onKeyPress={handleKeyPressSpecialCharacters}
                        value={smartPosStore.searchTemp}
                        onChange={(e: any) => {
                            smartPosStore.searchTemp = e.target.value
                            smartPosStore.allowSearch = true
                        }}
                    />
                </div>
                <div className="filter-tab">
                    <SelectStatus
                        onChange={(value: any) => {
                            smartPosStore.staticParam.status = value;
                            updateUrlParams()
                        }}
                        selected={() => {
                            return smartPosStore.staticParam.status || null;
                        }}
                        textOn="Hoạt động"
                        textOff="Ngưng hoạt động"
                    />
                </div>
                <div className="filter-tab">
                    <SelectCustom
                        list={vendorSmartPos}
                        placeholder="Vui lòng chọn"
                        showSearch
                        onChange={(value: any, name?: any) => {
                            smartPosStore.staticParam.vendor_name = value;
                            updateUrlParams()
                        }}
                        selected={() => {
                            return smartPosStore.staticParam.vendor_name || null;
                        }}
                        getLabel={(item: any) => item.name}
                    ></SelectCustom>
                </div>
                {(smartPosStore.staticParam.search || smartPosStore.staticParam.status || smartPosStore.staticParam.vendor_name) && (
                    <div className="remove-filter" onClick={() => {
                        handleRemoveFilters()
                    }}>
                        <span>Xóa Lọc</span>
                        <img src="/assets/icon/icon_close.svg" width={14} alt="delete" />
                    </div>
                )}
                <div className="action--add" onClick={() => {
                    smartPosStore.openModal = true;
                    smartPosStore.typeModal = "add";
                }}>
                    <span>
                      <img src="/assets/icon/plus.svg" alt="add"/>
                      Thêm mới
                    </span>
                </div>
            </div>
        </>
    )
}
export default observer(Filter)